import $http from './httpService';
import Promise from 'bluebird';
var SpService = (function () {
    function SpService() {
    }
    SpService.splitIntoWebAndList = function (url) {
        var uri = new URL(url);
        return $http({
            url: uri.origin + "/_vti_bin/rub/MySharePoint/MyTasks.svc/split?url=" + encodeURIComponent(url),
            method: 'POST'
        }).then(function (response) {
            if (response.data.info == 'OK') {
                var loadDigest = SpService.loadFormDigest;
                if (window.location.origin != uri.origin) {
                    loadDigest = function () { return Promise.resolve(''); };
                }
                return loadDigest(response.data.webUrl).then(function (digest) {
                    return {
                        webUrl: uri.origin + response.data.webUrl,
                        listUrl: uri.origin + response.data.listUrl,
                        listId: response.data.listId,
                        defaultDisplayFormUrl: uri.origin + response.data.defaultDisplayFormUrl,
                        defaultEditFormUrl: uri.origin + response.data.defaultEditFormUrl,
                        entityTypeName: response.data.entityTypeName,
                        fields: response.data.fields.reduce(function (agg, cur) {
                            agg[cur.name] = { title: cur.title, type: cur.type, choices: cur.choices };
                            return agg;
                        }, {}),
                        userId: response.data.userId,
                        digest: digest
                    };
                });
            }
            return Promise.reject(new Error(response.data.info));
        });
    };
    SpService.loadFormDigest = function (webUrl) {
        return $http({
            url: (webUrl + "/_api/contextinfo").replace(/^\/\//, '/'),
            method: 'POST'
        }).then(function (data) {
            return data.data.d.GetContextWebInformation.FormDigestValue;
        });
    };
    return SpService;
}());
export default SpService;
